import * as React from "react";
import { forwardRef } from "react";
const SvgMapmaker = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 40, viewBox: "0 0 30 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M30 15C30 30.8824 17.2059 39.2647 15 39.2647C12.7941 39.2647 0 30.8824 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z", fill: "current" }));
const ForwardRef = forwardRef(SvgMapmaker);
export { ForwardRef as ReactComponent };
